document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#CartDrawer') ||
    document.querySelector('.cart-drawer');

  if (!cartDrawer) {
    console.log('[CartDrawer] Not found.');
    return;
  }

  // Helper to get the scrollable element
  const getScrollArea = () =>
    cartDrawer.querySelector('.drawer__inner') || cartDrawer;

  const onWheelCapture = function (event) {
    // Log wheel detection
    /*
    console.log('[Wheel detected]', {
      target: event.target,
      deltaY: event.deltaY,
    });
    */

    // Only handle wheel events happening inside the cart drawer
    if (!cartDrawer.contains(event.target)) {
      // console.log('[Wheel ignored] Event outside cart drawer.');
      return;
    }

    const scrollArea = getScrollArea();

    if (!scrollArea) {
      // console.log('[ScrollArea missing]');
      return;
    }

    // Log before scroll
    // console.log('[Before scrollTop]:', scrollArea.scrollTop);

    // Block background page scroll
    event.preventDefault();
    event.stopPropagation();

    // Imitate dragging scrollbar: move scrollTop
    scrollArea.scrollTop += event.deltaY;

    // Log after scroll
    // console.log('[After scrollTop]:', scrollArea.scrollTop);
  };

  // Capture wheel events BEFORE browser handles scroll (Mac fix)
  document.addEventListener('wheel', onWheelCapture, {
    capture: true,
    passive: false,
  });

  // console.log('[CartDrawer Scroll Override Active]');
});